<template>
  <!-- 机器人置顶问题列表 猜你想问 气泡样式  -->
  <div class="question-list" v-if="(item.type === 7 && config.display === 1) || item.type === 8">
    <div class="question-list__title flex flex-between">
      <div v-html="getGuideContent(item)"></div>
      <div
        class="question-list__refresh flex flex-item-center"
        @click="handleChangeQuestion(item.quick_replies)"
        v-if="item.quick_replies.length > 5"
      >
        <el-icon size="14" style="margin-right: 4px"><Refresh /></el-icon>
        换一换
      </div>
    </div>
    <div
      @click="handleSendMsg(item.type, i)"
      class="question-list__item"
      :style="{ color: textColor }"
      v-for="i in item.quick_replies.slice(queIndex, queIndex + 5)"
      :key="i.id"
    >
      <div class="question-list__item-dot" :style="{ backgroundColor: textColor }"></div>
      {{ i.label }}
    </div>
  </div>
</template>
<script setup>
import { Refresh } from '@element-plus/icons-vue'
import { defineProps, computed, defineEmits, ref } from 'vue'
const props = defineProps({
  styleConfig: {
    type: Object,
    default: () => {}
  },
  item: {
    type: Object,
    default: () => {}
  },
  showType: {
    type: Number,
    default: 1
  }
})
const emit = defineEmits(['send'])
const config = computed(() => {
  if (props.styleConfig && Object.keys(props.styleConfig).length > 0) {
    return props.styleConfig
  } else {
    return {
      themeColor: '#3571F0',
      display: 1,
      guideWords: '',
      guide: {
        content: ''
      }
    }
  }
})
const textColor = computed(() => {
  return config.value.themeColor || '#3571F0'
  // return props.showType === 1 ? '#3571F0' : config.value.themeColor
})
const handleSendMsg = (type, data) => {
  data.id = data.knowledgeId || data.id
  data.type = data.knowledgeType
  if(type==8){
    data.question = data.question || ""
  }
  else {
    data.question = data.knowledgeName || ""
  }
  emit('send', type, data)
}
// 换一换置顶问题
const queIndex = ref(0)
const handleChangeQuestion = (arr) => {
  if (queIndex.value + 5 < arr.length) {
    queIndex.value += 5
  } else {
    queIndex.value = 0
  }
}
const getGuideContent = (item) => {
    if (item == null) {
      return ''
    }
    return item.type === 7 ? props.styleConfig.guideWords : props.styleConfig.guide?.content
}
</script>
<style lang="less" scoped>
.question-list {
  font-size: 14px;
  line-height: 1.8;
  &__item {
    color: #227fff;
    cursor: pointer;
    position: relative;
    padding-left: 12px;
  }
  &__item-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: calc(50% - 3px);
    background-color: #227fff;
  }
  &__title {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ececec;
  }
  &__refresh {
    font-size: 12px;
    color: #999999;
    cursor: pointer;
  }
}
</style>
